export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";